module.exports = __webpack_public_path__ + "img/beam-body-1.2728920e.png";